'use strict';

export default {
    id: 'tooltipShadow',

    afterInit( chart, _args, options ) {
        if ( chart.tooltip ) {
            const drawBackgroundOrig = chart.tooltip.drawBackground;

            chart.tooltip.drawBackground = function( pt, ctx, tooltipSize, options ) {
                const args = arguments;

                ctx.save();

                ctx.shadowOffsetX = 0;
                ctx.shadowOffsetY = 2;
                ctx.shadowBlur = 4;
                ctx.shadowColor = '#00000033';

                drawBackgroundOrig.apply( this, args );

                ctx.shadowOffsetX = 0;
                ctx.shadowOffsetY = 4;
                ctx.shadowBlur = 5;
                ctx.shadowColor = '#00000024';

                drawBackgroundOrig.apply( this, args );

                ctx.shadowOffsetX = 0;
                ctx.shadowOffsetY = 1;
                ctx.shadowBlur = 10;
                ctx.shadowColor = '#0000001f';

                drawBackgroundOrig.apply( this, args );

                ctx.restore();
            }
        }
    }
};
